<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Channels</h1>
          <div class="has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreateChannel' }"
              >Add</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredChannels"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="name" label="Name">
                <router-link
                  :to="{ name: 'EditChannel', params: { id: props.row.id } }"
                  >{{ props.row.name }}</router-link
                >
              </b-table-column>

              <b-table-column class="has-text-centered">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditChannel',
                        params: { id: props.row.id }
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'ManageChannelViewingSlots',
                        params: { id: props.row.id }
                      }"
                      >Manage Viewing Slots</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditSchedule',
                        params: { id: props.row.id }
                      }"
                      >Manage Schedule</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="confirmDelete(props.row)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No channels yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this channel?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteChannel()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import ChannelApi from '@/api/channels'
export default {
  name: 'ManageChannels',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Manage Channels'
  },
  computed: {
    ...mapGetters(['user']),
    filteredChannels() {
      if (this.search !== '' && this.channels.length > 0) {
        let query = this.search.toLowerCase()
        return this.channels.filter(item =>
          item.title.toLowerCase().includes(query)
        )
      } else {
        return this.channels
      }
    }
  },
  created() {
    this.fetchChannels()
  },
  data() {
    return {
      loading: true,
      channels: [],
      search: '',
      showConfirmModal: false,
      item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    confirmDelete(item) {
      this.showConfirmModal = true
      this.item = item
    },
    deleteChannel() {
      ChannelApi.remove(this.item.id)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Channel deleted successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchChannels()
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting channel',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    fetchChannels() {
      this.loading = true
      ChannelApi.getAll().then(channels => {
        this.channels = channels
        this.loading = false
      })
    }
  }
}
</script>
